(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["facets"] && !Shopify.designMode) return;
  try {
    // Per-group facet search (Categories / Themes / Size …). Purely client-side.
  //
  // The input sits inside Dawn's facet form, which submits on any `input` and
  // navigates on Enter. All three are blocked in the capture phase so nothing
  // here ever refetches the grid (the input has no `name`, so it is never sent).
  // `change` fires on blur and would reach the form even though `input` is stopped.
  document.addEventListener(
    'change',
    (event) => {
      if (event.target.closest('[data-facet-search]')) event.stopPropagation();
    },
    true
  );

  // Enter in a text input implicitly submits its form.
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter') return;
    if (event.target.closest('[data-facet-search]')) event.preventDefault();
  });

  document.addEventListener(
    'input',
    (event) => {
      const input = event.target.closest('[data-facet-search]');
      if (!input) return;
      event.stopPropagation();

      const group = input.closest('.parent-display');
      if (!group) return;

      const query = input.value.trim().toLowerCase();

      // Searching implies the full list, so the "+ N more" toggle steps aside.
      const showMore = group.querySelector('show-more-button');
      if (showMore) showMore.classList.toggle('js-search-hide', Boolean(query));

      let matchCount = 0;

      group.querySelectorAll('.facets__item').forEach((item) => {
        const labelEl = item.querySelector('.facet-checkbox__text-label');
        const text = (labelEl ? labelEl.textContent : item.textContent).toLowerCase();
        const matches = !query || text.indexOf(query) !== -1;
        if (matches) matchCount += 1;

        if (query) {
          // Reveal items collapsed behind "+ N more" so all matches are searchable.
          if (item.classList.contains('hidden')) {
            item.classList.add('js-search-was-hidden');
            item.classList.remove('hidden');
          }
          item.classList.toggle('js-search-hide', !matches);
        } else {
          item.classList.remove('js-search-hide');
          if (item.classList.contains('js-search-was-hidden')) {
            item.classList.add('hidden');
            item.classList.remove('js-search-was-hidden');
          }
        }
      });

      // textContent, never innerHTML — the query is whatever the shopper typed.
      const empty = group.querySelector('[data-facet-search-empty]');
      if (empty) {
        const noMatches = Boolean(query) && matchCount === 0;
        empty.textContent = noMatches ? '“' + input.value.trim() + '” not found' : '';
        empty.hidden = !noMatches;
      }
    },
    true
  );
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-filters"] && !Shopify.designMode) return;
  try {
    class MobileFilters extends HTMLElement {
    connectedCallback() {
      this._onDoc = (event) => {
        const trigger = event.target.closest('[data-mf-open]');
        if (trigger) {
          event.preventDefault();
          // e.g. the PLP's "+ More" chip opens straight on its facet's tab.
          if (trigger.dataset.mfOpenTab) this.selectTab(trigger.dataset.mfOpenTab);
          this.open();
        }
      };
      document.addEventListener('click', this._onDoc);
      this.addEventListener('click', this._onClick.bind(this));
      this.addEventListener('change', this._onChange.bind(this));
      this._closeTimer = null;
    }

    disconnectedCallback() {
      document.removeEventListener('click', this._onDoc);
    }

    _onClick(event) {
      if (event.target.closest('[data-mf-close]')) return this.close();
      if (event.target.closest('[data-mf-clear]')) return this.clearAll();
      if (event.target.closest('[data-mf-apply]')) return this.apply();
      // <price-buckets> handles its own selection first (it listens closer to the
      // target), so the new state is already set by the time this runs.
      const bucket = event.target.closest('.price-bucket');
      if (bucket) return this.updatePriceCount(bucket);
      const tab = event.target.closest('[data-mf-tab]');
      if (tab) this.selectTab(tab.dataset.mfTab);
    }

    _onChange(event) {
      if (event.target.classList.contains('mfilter__cb')) this.updateCount(event.target);
    }

    open() {
      clearTimeout(this._closeTimer);
      this.classList.remove('is-closing');
      requestAnimationFrame(() => this.classList.add('is-open'));
      document.documentElement.classList.add('mfilter-open');
    }

    close() {
      this.classList.remove('is-open');
      this.classList.add('is-closing');
      document.documentElement.classList.remove('mfilter-open');
      this._closeTimer = setTimeout(() => this.classList.remove('is-closing'), 300);
    }

    selectTab(index) {
      this.querySelectorAll('[data-mf-tab]').forEach((t) => t.classList.toggle('is-active', t.dataset.mfTab === index));
      this.querySelectorAll('[data-mf-panel]').forEach((p) => p.classList.toggle('is-active', p.dataset.mfPanel === index));
    }

    updateCount(checkbox) {
      const panel = checkbox.closest('[data-mf-panel]');
      if (!panel) return;
      this.setTabCount(panel, panel.querySelectorAll('.mfilter__cb:checked').length);
    }

    updatePriceCount(bucket) {
      const panel = bucket.closest('[data-mf-panel]');
      if (!panel) return;
      this.setTabCount(panel, panel.querySelectorAll('.price-bucket[aria-checked="true"]').length);
    }

    setTabCount(panel, count) {
      const dot = this.querySelector(`[data-mf-tab="${panel.dataset.mfPanel}"] [data-mf-tab-count]`);
      if (!dot) return;
      dot.textContent = count;
      dot.classList.toggle('is-hidden', count === 0);
    }

    clearAll() {
      this.querySelectorAll('.mfilter__cb:checked').forEach((cb) => (cb.checked = false));
      this.querySelectorAll('[data-mf-price]').forEach((input) => (input.value = ''));
      this.querySelectorAll('.price-bucket[aria-checked="true"]').forEach((bucket) => bucket.setAttribute('aria-checked', 'false'));
      this.querySelectorAll('[data-mf-tab-count]').forEach((dot) => {
        dot.textContent = '0';
        dot.classList.add('is-hidden');
      });
    }

    apply() {
      const params = new URLSearchParams();
      this.querySelectorAll('.mfilter__cb:checked').forEach((cb) => params.append(cb.name, cb.value));
      this.querySelectorAll('[data-mf-price]').forEach((input) => {
        if (input.value) params.append(input.name, input.value);
      });
      if (this.dataset.sort) params.set('sort_by', this.dataset.sort);
      const query = params.toString();
      window.location.href = this.dataset.url + (query ? `?${query}` : '');
    }
  }
  customElements.define('mobile-filters', MobileFilters);

  class MobileSort extends HTMLElement {
    connectedCallback() {
      this._onDoc = (event) => {
        if (event.target.closest('[data-ms-open]')) {
          event.preventDefault();
          this.open();
        }
      };
      document.addEventListener('click', this._onDoc);
      this.addEventListener('click', this._onClick.bind(this));
      this._closeTimer = null;
    }

    disconnectedCallback() {
      document.removeEventListener('click', this._onDoc);
    }

    _onClick(event) {
      if (event.target.closest('[data-ms-close]')) return this.close();
      const option = event.target.closest('[data-ms-value]');
      if (option) this.applySort(option.dataset.msValue);
    }

    open() {
      clearTimeout(this._closeTimer);
      this.classList.remove('is-closing');
      requestAnimationFrame(() => this.classList.add('is-open'));
      document.documentElement.classList.add('msort-open');
    }

    close() {
      this.classList.remove('is-open');
      this.classList.add('is-closing');
      document.documentElement.classList.remove('msort-open');
      this._closeTimer = setTimeout(() => this.classList.remove('is-closing'), 300);
    }

    applySort(value) {
      const params = new URLSearchParams(window.location.search);
      params.set('sort_by', value);
      window.location.href = `${this.dataset.url}?${params.toString()}`;
    }
  }
  customElements.define('mobile-sort', MobileSort);
  } catch(e) { console.error(e); }
})();

})();
